module.exports = __webpack_public_path__ + "img/checkIn.03588505.svg";